module.exports = __webpack_public_path__ + "img/17.89afc8dc.png";